import { transactionDateStore } from "hooks";

export const discountReportFilterState = (venue) => {
  const { venueId, startDate, endDate } = transactionDateStore(venue);
  return {
    venueId,
    page: 1,
    pageSize: 20,
    searchKey: "",
    dateRange: [startDate, endDate],
    locations: [],
    discount: null,
    sort: { key: "sales", value: "desc" },
  };
};
